module.exports = __webpack_public_path__ + "img/ump.355e4a59.png";